import React from 'react';

import asyncComponent from 'Demora/AsyncComponent';

import Layout from '../../js/components/Layout';

/**
 * The public marketing site. Keep this in step with the route list in
 * routes/web.php — Laravel has to serve the SPA shell for each of these
 * paths before the client router ever sees them.
 *
 * demora's Router renders one bare component per route, so the shared
 * chrome (skip link, brand header, footer, route-change announcements)
 * has to be part of the route component rather than a parent route.
 * Layout is imported eagerly so the header and footer are there on first
 * paint; only the page bodies are split out.
 */
function page(loader) {
	const Page = asyncComponent(loader);

	return function MarketingPage(props) {
		return (
			<Layout>
				<Page {...props} />
			</Layout>
		);
	};
}

export default [
	{
		path: '/',
		component: page(
			() => import(/* webpackChunkName: "vm-home" */ '../../js/pages/Home')
		),
	},
	{
		path: '/services',
		component: page(
			() =>
				import(
					/* webpackChunkName: "vm-services" */ '../../js/pages/Services'
				)
		),
	},
	{
		path: '/about',
		component: page(
			() =>
				import(/* webpackChunkName: "vm-about" */ '../../js/pages/About')
		),
	},
	{
		path: '/testimonials',
		component: page(
			() =>
				import(
					/* webpackChunkName: "vm-testimonials" */ '../../js/pages/Testimonials'
				)
		),
	},
	{
		path: '/faq',
		component: page(
			() => import(/* webpackChunkName: "vm-faq" */ '../../js/pages/Faq')
		),
	},
	{
		path: '/blog',
		component: page(
			() => import(/* webpackChunkName: "vm-blog" */ '../../js/pages/Blog')
		),
	},
	{
		path: '/contact',
		component: page(
			() =>
				import(
					/* webpackChunkName: "vm-contact" */ '../../js/pages/Contact'
				)
		),
	},
	{
		// Laravel's fallback route serves this SPA with a 404 status for
		// anything neither the marketing site nor demora claims, so the
		// client needs somewhere to land. demora's NoAuth/Routes keeps a
		// '*' entry last of all, after the package's own routes, so this
		// cannot shadow /login, /admin and the rest.
		path: '*',
		exact: false,
		component: page(
			() =>
				import(
					/* webpackChunkName: "vm-404" */ '../../js/pages/NotFound'
				)
		),
	},
];
